import ApplicationAdapter from './application';

export default class InsuranceClaim extends ApplicationAdapter {
  urlForUpdateRecord(_id, _modelName, _snapshot) {
    let urlForUpdateRecord = super.urlForUpdateRecord(...arguments);

    return `${urlForUpdateRecord}/submit`;
  }
}
